import { goldPrice } from "constants/customer-service";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Papa from "papaparse";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import "styles/page.css";
import "./GoldPrice.css";
import { convertDateFormat } from "utils";

const GoldPrice = () => {
  const [goldPrice, setGoldPrice] = useState({});

  const fetchGoldPrice = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/gold-prices?populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      setGoldPrice(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (_.isEmpty(goldPrice)) {
      fetchGoldPrice();
    }
  }, []);

  return (
    <>
      <div className="container page">
        <h1 className="page-title">Gold Price</h1>

        <Table responsive="xs" bordered>
          <thead>
            <tr className="table-title">
              <th>Indicative Gold Price</th>
              <th colSpan="2">
                As of{" "}
                {!_.isEmpty(goldPrice) && convertDateFormat(goldPrice.date)}
              </th>
            </tr>
            <tr className="table-head">
              <th>Weight</th>
              <th>Bank Buy (RM/Pc)</th>
              <th>Bank Sell (RM/Pc)</th>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(goldPrice) &&
              goldPrice?.goldPrices?.map((item, index) => {
                const formattedBankBuy =
                  !isNaN(item.bankBuy) &&
                  !isNaN(parseFloat(item.bankBuy)) &&
                  parseFloat(item.bankBuy).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 5,
                  });
                const formattedBankSell =
                  !isNaN(item.bankSell) &&
                  !isNaN(parseFloat(item.bankSell)) &&
                  parseFloat(item.bankSell).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 5,
                  });
                return (
                  <tr className="table-data" key={index}>
                    <td>{item.weight}</td>
                    <td>{formattedBankBuy}</td>
                    <td>{formattedBankSell}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>

        <div className="link">
          <Link to={"/personal/wealth/gold-i"}>
            View more info about Gold-<i>i</i> here.
          </Link>
        </div>
        <p className="page-subtitle">
          <b>Disclaimer:</b>
          <br />
          Rates displayed are indicative and subject to change without prior
          notice. Please call our Customer Care Consultants for the latest gold
          rates. Alternatively, visit our nearest branch for further enquiry on
          physical gold investment.
          <br />
          <br />
          The information contained in this page is for general information only
          and does not take into account your individual objectives, financial
          situations or needs. You should seek your own financial advice from an
          appropriately licensed advisor before investing. You should be aware
          that investments in physical gold carry risks. Prices and capital
          gain, if any, may rise or fall. Past performance of gold is not
          indicative of future performance. Please consider the fees and charges
          involved before investing. The specific risks associated to the
          physical gold investment are market risk, liquidity risk, regulatory
          and legal risk, and taxation risk. The physical gold bar or wafer will
          be issued upon receipt of completed purchase form and subject to terms
          and conditions therein. alrajhi bank Malaysia does not guarantee any
          returns on the investments.
          <br />
        </p>
      </div>
    </>
  );
};

export default GoldPrice;
